import { useAuth } from "providers/CustomAuthProvider";

const useGlobalPremiumFlag = () => {
  const { isPremium, isSystemAdmin } = useAuth();

  if (isSystemAdmin === true) {
    return true;
  }

  return isPremium === true;
};

export default useGlobalPremiumFlag;
